import {Popover} from "bootstrap";

// ----
// Constants
// ----

const CLOSE_BUTTON_HTML = "<button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\"></button>"

// ----
// Bootstrap hooks
// ----

$(document).ready(() => {
    // this enables popovers and tooltips globally and prevents the need for us to opt-in to enable them manually per-page
    injectBootstrapElements(document)

    // we need to always automatically select the first tab (if any) in order to correctly switch to the next when clicked
    const tabElements = $('[data-bs-toggle="tab"]')
    if (tabElements.length > 0) {
        bootstrap.Tab.getOrCreateInstance(tabElements.first()).show()
    }

    // enables modal show on click
    $(document).on("show.bs.modal", event => {
        let modalElement = $(event.target)
        let relatedElement = $(event.relatedTarget)

        if (modalElement.hasClass("dynamic-modal")) return;

        // extract title and body from the modal element
        let modalTitle = modalElement.find(".modal-title")
        let modalBody = modalElement.find(".modal-body")

        // check if all elements are existing before proceeding
        if (modalTitle !== undefined && modalBody !== undefined) {
            modalTitle.html(relatedElement.data("default-title") ?? "")
            modalBody.html(relatedElement.data("default-body") ?? "")

            // check if we need to load remote content
            let remoteContentLocation = relatedElement.data("modal-url") || relatedElement.data("remote")
            if (remoteContentLocation !== undefined) {
                // this allows us to detect the request
                const options = {headers: new Headers({'X-Requested-With': 'XMLHttpRequest'})}
                fetch(remoteContentLocation, options).then(response => {
                    if (response.status === 200) {
                        response.text().then(data => setModalContent(modalElement, data))
                    }
                }).catch(error => {
                    console.error(`Could not open modal ${remoteContentLocation}:`, error);
                });
            }
        }
    });

    // closes all popovers on click somewhere else
    $('body').on('click', event => {
        // check if the clicked element is not a popover toggle / a popover element
        const target = $(event.target)
        if (target.data('bs-toggle') !== 'popover'
            && target.parents('[data-bs-toggle="popover"]').length === 0
            && target.parents('.popover').length === 0
        ) {
            // close all open popovers
            $('[data-bs-toggle="popover"]').each((idx, element) => {
                const popoverInstance = Popover.getInstance(element)
                if (popoverInstance !== null) {
                    popoverInstance.hide()
                }
            })
        }
    });

    const modalTargetElement = $('#modal_target')
    modalTargetElement.on('click', 'input[type="submit"]', () => bootstrap.Modal.getOrCreateInstance(modalTargetElement).hide())
    modalTargetElement.on('click', 'button[type="submit"]', () => bootstrap.Modal.getOrCreateInstance(modalTargetElement).hide())

    $.fn.extend({
        dynamic_modal: function (data) {
            let modalElement = $(this);

            // initializes and shows the modal, then sets the content
            bootstrap.Modal.getOrCreateInstance(modalElement).show()
            setModalContent(modalElement, data);
        }
    });

    // observes changes made to the dom element, so we can detect lazy loaded elements
    const observer = new MutationObserver((mutations) => {
        mutations.forEach(mutation => mutation.addedNodes.forEach((value) => {
            const parentNode = value.parentNode
            if (parentNode !== null) {
                injectBootstrapElements(parentNode)
            }
        }))
    })

    observer.observe(document, {childList: true, subtree: true})
});

// -----
// Custom functions
// -----

function setModalContent(modalParentElement, content) {
    // get the target element
    if (content.includes("modal-title")) {
        let targetElement = modalParentElement.find(".modal-content")
        targetElement.html(content)
        targetElement.find(".modal-header").append(CLOSE_BUTTON_HTML)
    } else {
        let targetElement = modalParentElement.find(".modal-body")
        targetElement.html(content)
        targetElement.find(".modal-title").html("&nbsp;")
    }
}

function popoverOptions() {
    let additional_allow_list = { table: [], tbody: [], thead: [], tr: [], th: [], td: ['rowspan', 'colspan'] }
    let custom_allow_list = Object.assign(bootstrap.Tooltip.Default.allowList, additional_allow_list)
    return { allow_list: custom_allow_list }
}

function injectBootstrapElements(node) {
    node.querySelectorAll('[data-bs-toggle="tab"]').forEach((value) => bootstrap.Tab.getOrCreateInstance(value))
    node.querySelectorAll('[data-bs-toggle="modal"]').forEach((value) => bootstrap.Modal.getOrCreateInstance(value))
    node.querySelectorAll('[data-bs-toggle="popover"]').forEach((value) => bootstrap.Popover.getOrCreateInstance(value, popoverOptions()))
    node.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((value) => bootstrap.Tooltip.getOrCreateInstance(value))
    node.querySelectorAll('[data-bs-toggle="dropdown"]').forEach((value) => bootstrap.Dropdown.getOrCreateInstance(value))
}
